


















































import Vue, { PropType } from 'vue';

import { Outcome } from '@/models/packet';

import DialogCard from '@/components/DialogCard.vue';
import Icon from '@/components/Icon.vue';

export default Vue.extend({
  components: {
    DialogCard,
    Icon
  },

  props: {
    // In their current display order
    outcomes: {
      type: Array as PropType<Outcome[]>,
      required: true
    }
  },

  data() {
    return {
      order: this.outcomes.slice()
    };
  },

  computed: {
    isChanged(): boolean {
      return this.order.some(
        (outcome, index) => outcome.outcomeId !== this.outcomes[index].outcomeId
      );
    }
  },

  methods: {
    move(from: number, to: number) {
      const order = this.order.slice();
      [order[from], order[to]] = [order[to], order[from]];
      this.order = order;
    },

    save() {
      this.$emit('save', this.order);
    },

    close() {
      this.$emit('close');
    }
  }
});
